<script>
import { mapGetters } from "vuex"

import { getPWAThemePrimaryColor, getThemePrimaryColor } from "@/theme-helper"

import VueLoading from "vue-loading-overlay"

export default {
    name: "ThemedLoading",
    components: { VueLoading },
    props: {
        active: Boolean,
        isFullPage: {
            type: Boolean,
            default: true,
        },
        canCancel: Boolean,
        loader: {
            type: String,
            default: "spinner",
        },
        opacity: Number,
        size: { type: String, default: null },
    },
    data() {
        return {
            backgroundColor: "#101010",
            color: "#0db4ac",
        }
    },
    computed: {
        ...mapGetters("reduxi", {
            siteInfo: "getSiteInfo",
        }),
        loaderProps: function () {
            let config = {
                active: this.active,
                isFullPage: this.isFullPage,
                canCancel: this.canCancel,
                loader: this.loader,
                opacity: this.opacity,
                backgroundColor: this.backgroundColor,
                color: this.color,
            }

            if (this.size === "small") {
                config.height = 28
                config.width = 28
            }

            return config
        },
    },
    watch: {
        siteInfo: {
            immediate: true,
            handler: function (siteInfo) {
                let theme = siteInfo?.theme

                if (!theme) {
                    theme = "default"
                }

                this.color = getThemePrimaryColor(theme, siteInfo?.host)
                this.backgroundColor = getPWAThemePrimaryColor(theme, siteInfo?.host)
            },
        },
    },
}
</script>

<template>
    <VueLoading v-bind="loaderProps"></VueLoading>
</template>
